import normalNativeCommsReceiver from "./nativeCommsReceiver.normal";
import readonlyNativeCommsReceiver from "./nativeCommsReceiver.readonly";
import { loadData } from "./nativeCommsReceiver.shared";

let nativeCommsReceiver = null;

//#!if readonly !== true
// nativeCommsReceiver = normalNativeCommsReceiver;
//#!else
nativeCommsReceiver = readonlyNativeCommsReceiver;
//#!endif

export { loadData };
export default nativeCommsReceiver;
